import {
	ChangeDetectionStrategy,
	Component,
	EventEmitter,
	HostListener,
	Output,
	signal,
	inject,
	DestroyRef,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { IAiSuggestActions, ISmartSuggest } from '../../interfaces';
import { decrementIndex, incrementIndex } from '@app/core/utils/list-navigation-utils';
import { FileAiSuggestionService } from '@app/pages/files/services/file-ai-suggestion.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NgxTolgeeModule, TranslateService } from '@tolgee/ngx';

@Component({
	selector: 'smart-suggest-selector',
	imports: [CommonModule, MatIconModule, NgxTolgeeModule],
	templateUrl: './smart-suggest-selector.component.html',
	styleUrls: ['./smart-suggest-selector.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SmartSuggestSelectorComponent {
	private readonly fileAiSuggestionService = inject(FileAiSuggestionService);
	private readonly destroyRef = inject(DestroyRef);
	private readonly translateService = inject(TranslateService);

	@Output() emitSuggestion = new EventEmitter<IAiSuggestActions>();

	index = signal(0);

	smartSuggest: ISmartSuggest[] = [
		{
			name: 'classificationSuggestions',
			title: this.translateService.instant('action_center_smart_suggest_classify_files'),
			icon: 'category',
			description: this.translateService.instant(
				'action_center_smart_suggest_classify_files_description'
			),
		},
		{
			name: 'autoTagging',
			title: this.translateService.instant('action_center_smart_suggest_auto_tagging'),
			icon: 'smart-stars',
			description: this.translateService.instant(
				'action_center_smart_suggest_auto_tagging_description'
			),
		},
	];

	@HostListener('window:keydown', ['$event'])
	keyboardNav(event: KeyboardEvent) {
		if (event.key === 'ArrowUp') {
			this.index.set(decrementIndex(this.index(), this.smartSuggest.length));
		}
		if (event.key === 'ArrowDown') {
			this.index.set(incrementIndex(this.index(), this.smartSuggest.length));
			return;
		}
		if (event.key === 'Enter') {
			const action = this.smartSuggest[this.index()];
			if (!this.ongoingSuggestionAnalyze()) {
				this.emitSuggestion.emit(action.name);
			}
		}
	}
	ongoingSuggestionAnalyze() {
		let isOngoing = false;
		this.fileAiSuggestionService.ongoingSuggestionAnalyze$
			.pipe(takeUntilDestroyed(this.destroyRef))
			.subscribe(ongoing => {
				isOngoing = ongoing;
			});
		return isOngoing;
	}
}
